import React, { Fragment } from 'react';
import JobTrackerM from './compenent/JobTrackerM';


export function JobTracker() {
    return (
        <Fragment>
            <JobTrackerM />
        </Fragment>
    )
}
